module.exports = __webpack_public_path__ + "static/media/giatricotloi3.e88b9c2c.png";